import React, { JSX } from 'react';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Message, MessageClass } from './Message';

export interface Props {
  message: string;
  title?: string;
}

export const Warning = (props: Props): JSX.Element => {
  const { message } = props;
  const { title } = props;
  return (
    <Message
      message={message}
      messageClass={MessageClass.WARNING}
      icon={faExclamationTriangle}
      title={title}
    />
  );
};
